import { MODAL_TEMPLATES } from '@app/text-content';
import { BTN_CANCEL, BTN_CONTINUE } from '@text-content/button-templates';
import { ENTITY_TYPES, WIDGET_COMPONENT } from '@shared/types';
import { WIDGET_FAMILY } from '../../../../../config';
import { I18n } from '@app/i18n/strings-keys';
import { XVII18nService } from '@app/i18n/services';
import { getSingularEntityName } from '@app/shared/configs';

export const addPendingOrderModalOptions = (options: {
  i18nService: XVII18nService;
}) => ({
  title: MODAL_TEMPLATES.MODAL_TEMPLATE_CONFIRM.title,
  validation: true,
  modalClass: `modal-md hidden-header-checkbox`,
  buttons: [BTN_CONTINUE, BTN_CANCEL],
  value: {
    needToSave: true,
  },
  schema: {
    type: 'object',
    properties: {
      message: {
        type: 'string',
      },
      needToSave: {
        type: 'boolean',
      },
    },
  },
  formRules: {
    fields: {
      message: {
        widget: WIDGET_COMPONENT.label,
        widgetFamily: WIDGET_FAMILY.LEGACY,
        title: options.i18nService.instant(
          I18n.ConfirmMessages.SaveAndProcessUnsavedChanges,
          {
            entityType: options.i18nService.instant(
              getSingularEntityName(ENTITY_TYPES.ORDER),
            ),
          },
        ),
        class: 'standard-width',
      },
      needToSave: {
        title: I18n.Forms.OrderForm.SaveInventoryOrderForm,
        widget: WIDGET_COMPONENT.switch,
        widgetFamily: WIDGET_FAMILY.XUX,
        class: 'standard-width',
        widgetData: {
          checkedText: options.i18nService.instant(I18n.Common.Yes),
          uncheckedText: options.i18nService.instant(I18n.Common.No),
        },
      },
    },
  },
});
